import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

const client = axios.create({ baseURL: API, withCredentials: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anonymous

  useEffect(() => {
    client
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  async function register(data) {
    const r = await client.post("/auth/register", data);
    setUser(r.data.user);
    return r.data.user;
  }
  async function login(email, password) {
    const r = await client.post("/auth/login", { email, password });
    setUser(r.data.user);
    return r.data.user;
  }
  async function logout() {
    try {
      await client.post("/auth/logout");
    } catch {}
    setUser(null);
  }
  async function toggleFavorite(propertyId) {
    if (!user) throw new Error("Not authenticated");
    const isFav = (user.favorites || []).includes(propertyId);
    const url = `/me/favorites/${propertyId}`;
    const r = isFav ? await client.delete(url) : await client.post(url);
    setUser((u) => ({ ...u, favorites: r.data.favorites }));
  }

  return (
    <AuthContext.Provider value={{ user, register, login, logout, toggleFavorite }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
